import { Component, Input, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Reason } from '../../../../models/loyalty-reason.model';
import { Observable } from 'rxjs/Observable';
import { LoyaltyReasonService } from '../../../../services/loyalty/reason.service';
import { LoyaltyParamsService } from '../../../../services/loyalty/params.service';
import { FormValidationService } from '../../../../services/utils/form-validation.service';


@Component({
  selector: 'app-form-reason-loyalty',
  templateUrl: './form-reason-loyalty.component.html',
  styleUrls: ['./form-reason-loyalty.component.css']
})
export class FormReasonLoyaltyComponent implements OnInit {

  fields: any;
  form: FormGroup;
  @Input() resonId: string;
  @Input() editMode: boolean;
  paramsSign:  Array<{value: string, label: string}> = [{value: null, label: ''}];
  paramsType: Array<{value: string, label: string}> = [{value: null, label: ''}];
  public invalidSubmit: boolean;
  render = {
    sign: false,
    type: false,
    form: false
  };

  constructor(
    private translate: TranslateService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private fb: FormBuilder,
    private reasonService: LoyaltyReasonService,
    private paramService: LoyaltyParamsService,
    private validationService: FormValidationService
  ) { }

  ngOnInit() {

    this.reasonService.getFields().subscribe(res => {
      this.fields = res;
    });

    this.resonId = this.activatedRoute.snapshot.params['reasonId'];
    this.editMode = (typeof this.resonId !== 'undefined');
    let reason: Observable<any>;

    if (!this.editMode) {
      reason = Observable.of(new Reason());
    } else {
      reason = this.reasonService.get(this.resonId);
    }

    this.paramService.list(0, 200 , [{key: 'param_group', value: 'ReasonSign'}]).subscribe((res) => {
      for ( const param of res.data) {
        this.paramsSign.push({
          label: param.description,
          value: param.id
         });
      }
      this.render.sign = true;
    });

    this.paramService.list(0, 200, [{ key: 'param_group', value: 'ReasonType' }]).subscribe((res) => {
      for (const param of res.data) {
        this.paramsType.push({
          label: param.description,
          value: param.id
        });
      }
      this.render.type = true;

      reason.subscribe((res) => {

        this.form = this.fb.group({
          reason_code: [res.reason_code || ''],
          short_description: [res.short_description || ''],
          description: [res.description || ''],
          sign_pid: [res.sign_pid || ''],
          type_pid: [res.type_pid || '']
        });

        this.render.form = true;
      });
    });
  }

  save() {
    if (!this.form.valid) {
      this.invalidSubmit = true;
      return;
    }
    this.invalidSubmit = false;
    const reason = new Reason();
    reason.description = this.form.get('description').value;
    reason.reason_code = this.form.get('reason_code').value;
    reason.short_description = this.form.get('short_description').value;
    reason.sign_pid = this.form.get('sign_pid').value;
    reason.type_pid = this.form.get('type_pid').value;

    if (!this.editMode) {
      this.reasonService.create(reason).subscribe(res => {
        this.router.navigate(['/loyalty/reason']);
      });
    } else {
      reason.id = this.resonId;
      this.reasonService.update(reason).subscribe(res => {
        this.router.navigate(['/loyalty/reason']);
      });
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/views/loyalty/loyalty-reason/form-reason-loyalty/form-reason-loyalty.component.ts